import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';
import type { WireOverview } from '@logistics/contracts';
import { api } from '../client';
import { expectStatus } from '@/lib/result';

export const OVERVIEW_KEY = ['overview'] as const;

/** The overview numbers; the header reads it too, for uptime and the Health badge. */
export function useOverview(): UseQueryResult<WireOverview> {
  return useQuery({
    queryKey: OVERVIEW_KEY,
    queryFn: async () => expectStatus(await api.overview.summary(), 200),
    refetchInterval: 30_000,
  });
}
